import { render, staticRenderFns } from "./RelatedLinks.vue?vue&type=template&id=088e149c&scoped=true"
import script from "./RelatedLinks.vue?vue&type=script&lang=js"
export * from "./RelatedLinks.vue?vue&type=script&lang=js"
import style0 from "./RelatedLinks.vue?vue&type=style&index=0&id=088e149c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e149c",
  null
  
)

export default component.exports